import data from "../../../../../src/UnderlineNav.docs.json";
import * as React from 'react';
export default {
  data,
  React
};